namespace app.documentos {

    export class PdfObjectDirective implements ng.IDirective {

        public restrict: string = "E";

        public static factory() {
            return ($compile: ng.ICompileService, bowser) => {
                "ngInject";
                return new PdfObjectDirective($compile, bowser);
            };
        }

        public constructor(private $compile: ng.ICompileService, private bowser) {
            
        }

        public link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {
            let url = scope.$eval(attrs["src"]);
            if (this.bowser.msie) {
                element.html(
`<md-button class="md-fab md-accent" stf-visualizador-basico="'${url}'" aria-label="Imprimir">
    <md-icon md-font-icon="icon-printer"></md-icon>
</md-button>`
                        );

                let link = this.$compile(element.contents());
                
                link(scope);
            } else {
                element.replaceWith(`<object type="application/pdf" data="${url}" style="width: 100%; min-height: 480px;"></object>`);
            }
        }

    }

    angular.module("app.documentos").directive("stfPdfObject", PdfObjectDirective.factory());

}